import { graphql, useStaticQuery } from 'gatsby';

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          url
          image
          twitterUsername
          instagramUsername
        }
      }
    }
  `);
  return data.site.siteMetadata;
};